import { createSelector } from '@reduxjs/toolkit'

import { selectFinancialCockpitState } from './selectFinancialCockpitState'

export const selectCockpitPendingActionsUsers = createSelector(
  selectFinancialCockpitState,
  ({ users }) => users
)
